import { Select, Table } from 'antd';
import styled from 'styled-components';

import { Flex, Space } from '@/components/base';
import type { DashboardCardInfoT } from '@/features/Dashboard/types';
import { customScrollbar } from '@/styles/style';

import ChartTableConfigProvider from '../chart-table-config-provider';
import useChartTimeSeriesTableData from './useChartTimeSeriesTableData';

type Props = {
  chart: ChartBase & { name: string };
  tableData: ChartTableRes;
  onHistoricalChange: (value: boolean) => void;
  height?: number;
  dashboardCardInfo?: DashboardCardInfoT;
  yAxisTitle?: string;
};

const TimeSeriesTableChart = (props: Props) => {
  const { columns, dataSource } = useChartTimeSeriesTableData(props);

  return (
    <Style style={{ height: props.height || 360 }}>
      <Flex j="flex-end">
        <Select
          style={{ width: 120 }}
          value={props.chart.historical.value}
          options={[
            {
              label: 'Total',
              value: false,
            },
            {
              label: 'Historical',
              value: true,
            },
          ]}
          onChange={props.onHistoricalChange}
        />
      </Flex>
      <Space h={16} />
      <ChartTableConfigProvider>
        <Table
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          bordered
          scroll={{
            x: 'max-content',
          }}
        />
      </ChartTableConfigProvider>
    </Style>
  );
};

const Style = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  overflow: auto;
  ${customScrollbar};

  .ant-table-thead th {
    background-color: ${({ theme }) => theme.colors.gray200} !important;
    padding: 10px 16px !important;
    font-weight: 500 !important;
  }

  .ant-table-row td {
    background-color: ${({ theme }) => theme.colors.gray100};
    padding: 12px 16px !important;
  }

  .ellipsis {
    font-size: 12px;
  }
`;

export default TimeSeriesTableChart;
